/** Capabilities normalisées d'un modèle LLM (source discover, stockées en JSONB). */
export interface U3202ModelCapabilities {
  max_input_tokens?: number;
  max_tokens?: number;
  streaming?: { supported: boolean };
  effort?: { supported: boolean; levels?: string[] };
  thinking?: { supported: boolean; types?: Record<string, boolean> };
  image_input?: { supported: boolean };
  pdf_input?: { supported: boolean };
  structured_outputs?: { supported: boolean };
  [key: string]: unknown;
}

export const U3202_EMPTY_CAPABILITIES: U3202ModelCapabilities = {};

export type U3202CapabilityKey =
  | 'streaming'
  | 'image_input'
  | 'pdf_input'
  | 'structured_outputs'
  | 'effort'
  | 'thinking';
